module.exports = __webpack_public_path__ + "assets/img/b1b14491a751f1f70f5e046dbd63cbcd.png";